var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('tabela',{attrs:{"loading":_vm.loading,"items":_vm.items},on:{"rechargeTable":function($event){return _vm.getAll()}}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }